import React, { useEffect, useState } from "react";
import { BookOpen, ExternalLink } from "lucide-react";
import api from "@/lib/api";

const JOURNAL = "https://gcsb.uk/journal";

const PaperCard = ({ p }) => (
  <a href={JOURNAL} target="_blank" rel="noopener noreferrer" className="card-warm p-5 block hover:border-[var(--ink)] transition-colors" data-testid={`csi-journal-paper-${p.reference || p.title}`}>
    <div className="flex flex-wrap items-center gap-2 text-[11px] font-mono text-zinc-500">
      {p.reference && <span className="rounded-full bg-[var(--navy)] text-white px-2 py-0.5">{p.reference}</span>}
      {p.volume && <span>{p.volume}</span>}
      {p.published_on && <span>Published {new Date(p.published_on).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}</span>}
    </div>
    <h4 className="font-display text-xl mt-2 leading-snug">{p.title}</h4>
    <div className="text-sm text-zinc-700 mt-1">{p.authors}</div>
    {p.abstract && <p className="text-sm text-zinc-600 mt-2 line-clamp-3">{p.abstract}</p>}
    <div className="text-xs font-semibold text-[var(--terracotta)] mt-3 inline-flex items-center gap-1">Read in the GCSB Journal <ExternalLink size={12}/></div>
  </a>
);

export const CsiJournalPapers = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/journal/csi-papers").then((r) => setData(r.data)).catch(() => setData({ papers: [] })); }, []);
  if (!data) return null;
  return (
    <div className="mt-6" data-testid="csi-journal-papers">
      <div className="eyebrow mb-2 inline-flex items-center gap-1.5"><BookOpen size={13}/> CSI in the GCSB Journal</div>
      {data.papers.length ? (
        <div className="grid md:grid-cols-2 gap-4">{data.papers.map((p) => <PaperCard key={p.reference || p.title} p={p}/>)}</div>
      ) : (
        <p className="text-sm text-zinc-600" data-testid="csi-journal-empty">
          No papers by CSI graduates or faculty have been published yet - the first issue of the Journal is in preparation.
          Accepted papers by CSI authors will appear here automatically.
        </p>
      )}
    </div>
  );
};
